import { FlipToBack, FlipToFront } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import scssVariables from '../../../../Config.module.scss';
import styles from './FlipCard.module.scss';

export interface IFlipCardProps {
    children: React.ReactNode;
    initialFlipped?: boolean;
    enableHoverBlurFirst?: boolean;
    hoverBlurAmount?: number;
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    ariaLabelFlip?: string;
    ariaLabelFlipBack?: string;
    iconToBack?: React.ReactNode;
    iconToFront?: React.ReactNode;
    tooltipToBack?: string;
    tooltipToFront?: string;
}

const FlipCard: React.FC<IFlipCardProps> = (props: IFlipCardProps) => {
    const childArray = React.Children.toArray(props.children);
    if (childArray.length !== 2) {
        return props.children as React.ReactElement;
    }

    const [flipped, setFlipped] = useState(props.initialFlipped ?? false);
    const [hoverButton, setHoverButton] = useState(false);

    const blurAmount = props.hoverBlurAmount ?? 4;

    const shouldBlur = !!(props.enableHoverBlurFirst && !flipped && hoverButton);

    const toBackIcon = props.iconToBack ?? <FlipToBack fontSize="medium" />;
    const toFrontIcon = props.iconToFront ?? <FlipToFront fontSize="medium" />;

    const tooltipToBack = props.tooltipToBack ?? props.ariaLabelFlip;
    const tooltipToFront = props.tooltipToFront ?? props.ariaLabelFlipBack;
    const tooltipTitle = flipped ? tooltipToFront : tooltipToBack;

    return (
        <Box
            className={`${styles.flip_card_root} ${props.className ?? ''}`}
            style={{
                ...props.style,
                width: props.width,
                height: props.height ?? 'auto',
                ['--flip-blur' as any]: `${blurAmount}px`,
            }}
        >
            <div className={`${styles.flip_card_inner} ${flipped ? styles.is_flipped : ''}`}>
                <div className={`${styles.flip_card_face} ${styles.flip_card_front} ${shouldBlur ? styles.is_blurred : ''}`}>{childArray[0]}</div>

                <div className={`${styles.flip_card_face} ${styles.flip_card_back}`}>{childArray[1]}</div>
            </div>

            <Tooltip title={tooltipTitle}>
                <IconButton
                    size="medium"
                    className={styles.flip_card_btn}
                    onMouseEnter={() => setHoverButton(true)}
                    onMouseLeave={() => setHoverButton(false)}
                    onBlur={() => setHoverButton(false)}
                    onClick={() => setFlipped((f) => !f)}
                    aria-label={flipped ? props.ariaLabelFlipBack : props.ariaLabelFlip}
                    sx={{
                        '& svg': { color: scssVariables.flipCardColor, transition: 'color 0.18s ease' },
                        '&:hover svg, &:focus-visible svg': { color: scssVariables.flipCardColor },
                        '&:hover, &:focus-visible': {
                            backgroundColor: scssVariables.plainWhite,
                            boxShadow: scssVariables.flipCardBoxShadow,
                        },
                    }}
                >
                    {flipped ? toFrontIcon : toBackIcon}
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default FlipCard;
